import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/no_data1.png'


const _withScopeId = n => (_pushScopeId("data-v-7c9f2d5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "contaienr"
}
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "pagination" }
const _hoisted_4 = {
  key: 1,
  class: "no_data_contaienr"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no_data1",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "tips" }

import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import ProoductItem from './ProoductItem.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['pageNum', 'pageSize', 'data', 'banner'],
  emits: ['update:pageNum', 'update:pageSize'],
  setup(__props, { emit }) {

const props = __props



const currentChange = (event: any) => {
  const el = document.querySelector('#app .el-scrollbar__wrap')
  el && el.scroll(0, 0)
  emit('update:pageNum', event)
}

const sizeChange = (event: any) => {
  const el = document.querySelector('#app .el-scrollbar__wrap')
  el && el.scroll(0, 0)
  emit('update:pageNum', 1)
  emit('update:pageSize', event)
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (__props.data?.records?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.records, (item, index) => {
            return _renderSlot(_ctx.$slots, "default", _normalizeProps(_mergeProps({ key: index }, { item, index })))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev,pager,next,sizes",
            currentPage: __props.pageNum,
            "page-size": __props.pageSize,
            total: __props.data.total,
            onCurrentChange: _cache[0] || (_cache[0] = ($event: any) => (currentChange($event))),
            onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (sizeChange($event)))
          }, null, 8, ["currentPage", "page-size", "total"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('暂无相关搜索结果')), 1)
      ]))
}
}

})